import { Injectable } from '@angular/core';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem
} from 'src/app/utils/browser-storage';

@Injectable({
  providedIn: 'root'
})
export class UserLocalSelectionService {

  constructor() { }

  setSelection(selection: any, key: string): void {
    setLocalStorageItem(key, JSON.stringify(selection));
  }

  getSelection(key: string): any | null {
    const value = getLocalStorageItem(key);
    return value ? JSON.parse(value) : null;
  }

  clearSelection(key: string): void {
    removeLocalStorageItem(key);
  }
}
